import React from 'react';
import { Text, View } from 'react-native';
import { modalExperience } from '../../shared/modals/modalExperience.styles';
import type { CustomerAccountRow } from '../domain/customerTypes';

const TAX_CATEGORY_LABELS: Record<string, string> = {
  consumidor_final: 'Consumidor Final',
  monotributo: 'Monotributista',
  responsable_inscripto: 'Responsable Inscripto',
  exento: 'Exento',
};

type Props = {
  customer: CustomerAccountRow;
};

export function CustomerDetailCommercialTerms({ customer }: Props) {
  const hasErpInfo = !!(customer.taxCategory || customer.paymentTermsDays);
  if (!hasErpInfo) return null;

  return (
    <View style={modalExperience.detailFlatSection}>
      <Text style={modalExperience.detailBlockTitle}>IVA y plazos</Text>
      {customer.taxCategory ? (
        <View style={modalExperience.detailKvRow}>
          <Text style={modalExperience.detailMetaLabel}>Categoría IVA</Text>
          <Text style={modalExperience.detailKvValueStrong}>
            {TAX_CATEGORY_LABELS[customer.taxCategory] ?? customer.taxCategory}
          </Text>
        </View>
      ) : null}
      {customer.paymentTermsDays != null && customer.paymentTermsDays > 0 ? (
        <View style={modalExperience.detailKvRow}>
          <Text style={modalExperience.detailMetaLabel}>Días de pago</Text>
          <Text style={modalExperience.detailKvValueStrong}>{customer.paymentTermsDays} días</Text>
        </View>
      ) : null}
    </View>
  );
}
